import { Box, CircularProgress } from "@mui/material";
import Text from "$components/Text";

interface LoaderProps {
  text?: string;
}

export const Loader = ({ text = "Chargement..." }: LoaderProps) => {
  return (
    <Box display="flex" alignItems="center">
      <CircularProgress />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Text>{text}</Text>
    </Box>
  );
};
